// Generated by purs version 0.15.4
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Apply from "../Control.Apply/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Control_Monad_State_Class from "../Control.Monad.State.Class/index.js";
import * as Data_Array from "../Data.Array/index.js";
import * as Data_Either from "../Data.Either/index.js";
import * as Data_Enum from "../Data.Enum/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_HeytingAlgebra from "../Data.HeytingAlgebra/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Number from "../Data.Number/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_String_Common from "../Data.String.Common/index.js";
import * as Data_String_Utils from "../Data.String.Utils/index.js";
import * as Data_Traversable from "../Data.Traversable/index.js";
import * as Data_Unit from "../Data.Unit/index.js";
import * as Effect_Aff_Class from "../Effect.Aff.Class/index.js";
import * as Halogen_Component from "../Halogen.Component/index.js";
import * as Halogen_HTML_Core from "../Halogen.HTML.Core/index.js";
import * as Halogen_HTML_Elements from "../Halogen.HTML.Elements/index.js";
import * as Halogen_HTML_Events from "../Halogen.HTML.Events/index.js";
import * as Halogen_HTML_Properties from "../Halogen.HTML.Properties/index.js";
import * as Halogen_Query_HalogenM from "../Halogen.Query.HalogenM/index.js";
import * as PartyCarlo_Capability_LogMessages from "../PartyCarlo.Capability.LogMessages/index.js";
import * as PartyCarlo_Capability_Now from "../PartyCarlo.Capability.Now/index.js";
import * as PartyCarlo_Capability_Random from "../PartyCarlo.Capability.Random/index.js";
import * as PartyCarlo_Capability_Sleep from "../PartyCarlo.Capability.Sleep/index.js";
import * as PartyCarlo_Components_HTML_Footer from "../PartyCarlo.Components.HTML.Footer/index.js";
import * as PartyCarlo_Components_HTML_Loading from "../PartyCarlo.Components.HTML.Loading/index.js";
import * as PartyCarlo_Components_HTML_ResultCircle from "../PartyCarlo.Components.HTML.ResultCircle/index.js";
import * as PartyCarlo_Components_HTML_Utils from "../PartyCarlo.Components.HTML.Utils/index.js";
import * as PartyCarlo_Data_Display from "../PartyCarlo.Data.Display/index.js";
import * as PartyCarlo_Data_Probability from "../PartyCarlo.Data.Probability/index.js";
import * as PartyCarlo_Data_Result from "../PartyCarlo.Data.Result/index.js";
import * as PartyCarlo_Data_SortedArray from "../PartyCarlo.Data.SortedArray/index.js";
import * as PartyCarlo_MonteCarlo from "../PartyCarlo.MonteCarlo/index.js";
import * as PartyCarlo_Pages_Home_Error from "../PartyCarlo.Pages.Home.Error/index.js";
import * as PartyCarlo_Pages_Home_Logs from "../PartyCarlo.Pages.Home.Logs/index.js";
import * as PartyCarlo_Utils from "../PartyCarlo.Utils/index.js";
var not = /* #__PURE__ */ Data_HeytingAlgebra.not(/* #__PURE__ */ Data_HeytingAlgebra.heytingAlgebraFunction(Data_HeytingAlgebra.heytingAlgebraBoolean));
var map = /* #__PURE__ */ Data_Functor.map(Data_Functor.functorArray);
var sequence = /* #__PURE__ */ Data_Traversable.sequence(Data_Traversable.traversableArray)(Data_Either.applicativeEither);
var bindFlipped = /* #__PURE__ */ Control_Bind.bindFlipped(Data_Either.bindEither);
var fromArray = /* #__PURE__ */ PartyCarlo_Data_SortedArray.fromArray(Data_Ord.ordInt);
var apply = /* #__PURE__ */ Control_Apply.apply(Data_Maybe.applyMaybe);
var map1 = /* #__PURE__ */ Data_Functor.map(Data_Maybe.functorMaybe);
var confidenceInterval = /* #__PURE__ */ PartyCarlo_MonteCarlo.confidenceInterval(Data_Ord.ordInt);
var succ = /* #__PURE__ */ Data_Enum.succ(PartyCarlo_Data_Result.enumInterval);
var pred = /* #__PURE__ */ Data_Enum.pred(PartyCarlo_Data_Result.enumInterval);
var discard = /* #__PURE__ */ Control_Bind.discard(Control_Bind.discardUnit);
var display = /* #__PURE__ */ PartyCarlo_Data_Display.display(PartyCarlo_Data_Result.displayInterval);
var display1 = /* #__PURE__ */ PartyCarlo_Data_Display.display(PartyCarlo_Pages_Home_Error.displayError);
var value = /* #__PURE__ */ Halogen_HTML_Properties.value(Halogen_HTML_Core.isPropString);
var bind = /* #__PURE__ */ Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM);
var get = /* #__PURE__ */ Control_Monad_State_Class.get(Halogen_Query_HalogenM.monadStateHalogenM);
var Data = /* #__PURE__ */ (function () {
    function Data(value0) {
        this.value0 = value0;
    };
    Data.create = function (value0) {
        return new Data(value0);
    };
    return Data;
})();
var Results = /* #__PURE__ */ (function () {
    function Results(value0) {
        this.value0 = value0;
    };
    Results.create = function (value0) {
        return new Results(value0);
    };
    return Results;
})();
var Loading = /* #__PURE__ */ (function () {
    function Loading() {

    };
    Loading.value = new Loading();
    return Loading;
})();
var ReceiveInput = /* #__PURE__ */ (function () {
    function ReceiveInput(value0) {
        this.value0 = value0;
    };
    ReceiveInput.create = function (value0) {
        return new ReceiveInput(value0);
    };
    return ReceiveInput;
})();
var ButtonPress = /* #__PURE__ */ (function () {
    function ButtonPress() {

    };
    ButtonPress.value = new ButtonPress();
    return ButtonPress;
})();
var ClearDefaultText = /* #__PURE__ */ (function () {
    function ClearDefaultText() {

    };
    ClearDefaultText.value = new ClearDefaultText();
    return ClearDefaultText;
})();
var ResultUp = /* #__PURE__ */ (function () {
    function ResultUp() {

    };
    ResultUp.value = new ResultUp();
    return ResultUp;
})();
var ResultDown = /* #__PURE__ */ (function () {
    function ResultDown() {

    };
    ResultDown.value = new ResultDown();
    return ResultDown;
})();
var stripInput = function (s) {
    return Data_Array.filter(not(Data_String_Common["null"]))(map(Data_String_Common.trim)(Data_String_Utils.lines(s)));
};
var parseNum = function (s) {
    return Data_Maybe.maybe(new Data_Either.Left(new PartyCarlo_Pages_Home_Error.InvalidNumber(s)))(Data_Either.Right.create)(Data_Number.fromString(s));
};
var parse = function (input) {
    return sequence(map(function (s) {
        return bindFlipped((function () {
            var $109 = PartyCarlo_Utils.mapLeft(PartyCarlo_Pages_Home_Error.InvalidProbability.create(s));
            return function ($110) {
                return $109(PartyCarlo_Data_Probability.mkProbability($110));
            };
        })())(parseNum(s));
    })(input));
};
var experimentCount = 100000;
var runExperiments = function (dictMonadAff) {
    var Monad0 = (dictMonadAff.MonadEffect0()).Monad0();
    var bind1 = Control_Bind.bind(Monad0.Bind1());
    var liftAff = Effect_Aff_Class.liftAff(dictMonadAff);
    var pure = Control_Applicative.pure(Monad0.Applicative0());
    return function (dictRandom) {
        return function (dist) {
            return bind1(liftAff(PartyCarlo_MonteCarlo.parSample(experimentCount)(dist)))(function (samples) {
                var sorted = fromArray(samples);
                var result = apply(apply(apply(map1(function (p90val) {
                    return function (p95val) {
                        return function (p99val) {
                            return function (p999val) {
                                return {
                                    dist: sorted,
                                    p90: p90val,
                                    p95: p95val,
                                    p99: p99val,
                                    p999: p999val
                                };
                            };
                        };
                    };
                })(confidenceInterval(PartyCarlo_Data_Probability.p90)(sorted)))(confidenceInterval(PartyCarlo_Data_Probability.p95)(sorted)))(confidenceInterval(PartyCarlo_Data_Probability.p99)(sorted)))(confidenceInterval(PartyCarlo_Data_Probability.p999)(sorted));
                return pure(Data_Either.note(PartyCarlo_Pages_Home_Error.ExperimentsFailed.value)(result));
            });
        };
    };
};
var defaultTextAreaValue = /* #__PURE__ */ (function () {
    return "Enter a list of probabilities: One for each attendee.\x0a\x0a" + ("Hit the button above to get a confidence interval for overall attendance.\x0a\x0a" + ("ex.\x0a\x0a" + ".1\x0a.99\x0a.5"));
})();
var handleAction$prime = function (dictLogMessages) {
    var Monad0 = dictLogMessages.Monad0();
    var pure = Control_Applicative.pure(Monad0.Applicative0());
    var Bind1 = Monad0.Bind1();
    var discard1 = discard(Bind1);
    var log = PartyCarlo_Pages_Home_Logs.log(dictLogMessages);
    var bind1 = Control_Bind.bind(Bind1);
    return function (dictNow) {
        var log1 = log(dictNow);
        var nowDateTime = PartyCarlo_Capability_Now.nowDateTime(dictNow);
        return function (dictRandom) {
            return function (dictSleep) {
                var sleep = PartyCarlo_Capability_Sleep.sleep(dictSleep);
                var runExperiments1 = runExperiments(dictSleep.MonadAff0())(dictRandom);
                return function (dictMonadState) {
                    var put = Control_Monad_State_Class.put(dictMonadState);
                    return function (v) {
                        return function (v1) {
                            if (v instanceof Data && v1 instanceof ClearDefaultText) {
                                var $89 = v.value0.input === defaultTextAreaValue;
                                if ($89) {
                                    return put(new Data({
                                        input: "",
                                        e: v.value0.e
                                    }));
                                };
                                return pure(Data_Unit.unit);
                            };
                            if (v1 instanceof ClearDefaultText) {
                                return pure(Data_Unit.unit);
                            };
                            if (v instanceof Results && v1 instanceof ResultUp) {
                                return put(new Results({
                                    input: v.value0.input,
                                    result: v.value0.result,
                                    show: Data_Maybe.fromMaybe(v.value0.show)(succ(v.value0.show))
                                }));
                            };
                            if (v instanceof Results && v1 instanceof ResultDown) {
                                return put(new Results({
                                    input: v.value0.input,
                                    result: v.value0.result,
                                    show: Data_Maybe.fromMaybe(v.value0.show)(pred(v.value0.show))
                                }));
                            };
                            if (v1 instanceof ResultUp) {
                                return pure(Data_Unit.unit);
                            };
                            if (v1 instanceof ResultDown) {
                                return pure(Data_Unit.unit);
                            };
                            if (v instanceof Data && v1 instanceof ReceiveInput) {
                                return put(new Data({
                                    input: v1.value0,
                                    e: Data_Maybe.Nothing.value
                                }));
                            };
                            if (v1 instanceof ReceiveInput) {
                                return pure(Data_Unit.unit);
                            };
                            if (v instanceof Results && v1 instanceof ButtonPress) {
                                return discard1(log1(new PartyCarlo_Pages_Home_Logs.PartyCarloButtonPressed(PartyCarlo_Pages_Home_Logs.ResultsState.value)))(function () {
                                    return discard1(log1(new PartyCarlo_Pages_Home_Logs.Transition(PartyCarlo_Pages_Home_Logs.ResultsState.value, PartyCarlo_Pages_Home_Logs.DataState.value)))(function () {
                                        return put(new Data({
                                            e: Data_Maybe.Nothing.value,
                                            input: v.value0.input
                                        }));
                                    });
                                });
                            };
                            if (v instanceof Data && v1 instanceof ButtonPress) {
                                return discard1(log1(new PartyCarlo_Pages_Home_Logs.PartyCarloButtonPressed(PartyCarlo_Pages_Home_Logs.DataState.value)))(function () {
                                    return discard1(log1(PartyCarlo_Pages_Home_Logs.RunAction.value))(function () {
                                        var v2 = parse(stripInput(v.value0.input));
                                        if (v2 instanceof Data_Either.Left) {
                                            return discard1(log1(new PartyCarlo_Pages_Home_Logs.ParsingFailed(v2.value0)))(function () {
                                                return put(new Data({
                                                    input: v.value0.input,
                                                    e: new Data_Maybe.Just(v2.value0)
                                                }));
                                            });
                                        };
                                        if (v2 instanceof Data_Either.Right) {
                                            return discard1(log1(new PartyCarlo_Pages_Home_Logs.ParsedNProbabilities(v2.value0)))(function () {
                                                return discard1(log1(new PartyCarlo_Pages_Home_Logs.Distribution(v2.value0)))(function () {
                                                    return discard1(log1(new PartyCarlo_Pages_Home_Logs.RunningNExperiments(experimentCount)))(function () {
                                                        return discard1(put(Loading.value))(function () {
                                                            return discard1(sleep(0.0))(function () {
                                                                return bind1(nowDateTime)(function (start) {
                                                                    return bind1(runExperiments1(v2.value0))(function (exp) {
                                                                        if (exp instanceof Data_Either.Left) {
                                                                            return discard1(log1(PartyCarlo_Pages_Home_Logs.MonteCarloFailed.value))(function () {
                                                                                return put(new Data({
                                                                                    input: v.value0.input,
                                                                                    e: new Data_Maybe.Just(exp.value0)
                                                                                }));
                                                                            });
                                                                        };
                                                                        if (exp instanceof Data_Either.Right) {
                                                                            return discard1(put(new Results({
                                                                                input: v.value0.input,
                                                                                result: exp.value0,
                                                                                show: PartyCarlo_Data_Result.P95.value
                                                                            })))(function () {
                                                                                return bind1(nowDateTime)(function (end) {
                                                                                    return discard1(log1(new PartyCarlo_Pages_Home_Logs.CalculationDuration(start, end)))(function () {
                                                                                        return log1(new PartyCarlo_Pages_Home_Logs.Intervals(exp.value0));
                                                                                    });
                                                                                });
                                                                            });
                                                                        };
                                                                        throw new Error("Failed pattern match at PartyCarlo.Pages.Home (line 246, column 13 - line 258, column 38): " + [ exp.constructor.name ]);
                                                                    });
                                                                });
                                                            });
                                                        });
                                                    });
                                                });
                                            });
                                        };
                                        throw new Error("Failed pattern match at PartyCarlo.Pages.Home (line 234, column 5 - line 258, column 38): " + [ v2.constructor.name ]);
                                    });
                                });
                            };
                            if (v1 instanceof ButtonPress) {
                                return pure(Data_Unit.unit);
                            };
                            throw new Error("Failed pattern match at PartyCarlo.Pages.Home (line 180, column 1 - line 189, column 14): " + [ v.constructor.name, v1.constructor.name ]);
                        };
                    };
                };
            };
        };
    };
};
var component = function (dictMonadAff) {
    return function (dictLogMessages) {
        var handleAction$prime1 = handleAction$prime(PartyCarlo_Capability_LogMessages.logMessagesHalogenM(dictLogMessages));
        return function (dictNow) {
            var handleAction$prime2 = handleAction$prime1(PartyCarlo_Capability_Now.nowHalogenM(dictNow));
            return function (dictRandom) {
                var handleAction$prime3 = handleAction$prime2(PartyCarlo_Capability_Random.logMessagesHalogenM(dictRandom));
                return function (dictSleep) {
                    var handleAction$prime4 = handleAction$prime3(PartyCarlo_Capability_Sleep.nowHalogenM(dictSleep))(Halogen_Query_HalogenM.monadStateHalogenM);
                    var titleButton = Halogen_HTML_Elements.h1([ PartyCarlo_Components_HTML_Utils.css("neon noselect"), Halogen_HTML_Events.onClick(function (v) {
                        return ButtonPress.value;
                    }) ])([ Halogen_HTML_Core.text("Party Carlo") ]);
                    var renderToggleRow = function (state) {
                        var showInterval = (function () {
                            if (state instanceof Results) {
                                return [ Halogen_HTML_Elements.div_([ Halogen_HTML_Core.text(display(state.value0.show)) ]), Halogen_HTML_Elements.div_([ Halogen_HTML_Core.text("confidence") ]) ];
                            };
                            return [ Halogen_HTML_Elements.div_([ Halogen_HTML_Core.text("") ]), Halogen_HTML_Elements.div_([ Halogen_HTML_Core.text("") ]) ];
                        })();
                        return Halogen_HTML_Elements.div([ PartyCarlo_Components_HTML_Utils.css("hcontainer togglerow") ])([ Halogen_HTML_Elements.div([ PartyCarlo_Components_HTML_Utils.css("toggle neon noselect"), Halogen_HTML_Properties.id("left"), Halogen_HTML_Events.onClick(function (v) {
                            return ResultDown.value;
                        }) ])([ Halogen_HTML_Core.text("\u2190") ]), Halogen_HTML_Elements.div([ PartyCarlo_Components_HTML_Utils.css("vcontainer show-interval") ])(showInterval), Halogen_HTML_Elements.div([ PartyCarlo_Components_HTML_Utils.css("toggle neon noselect"), Halogen_HTML_Properties.id("right"), Halogen_HTML_Events.onClick(function (v) {
                            return ResultUp.value;
                        }) ])([ Halogen_HTML_Core.text("\u2192") ]) ]);
                    };
                    var render = function (v) {
                        if (v instanceof Data) {
                            return Halogen_HTML_Elements.div([ Halogen_HTML_Properties.id("root"), PartyCarlo_Components_HTML_Utils.css("vcontainer") ])([ titleButton, Halogen_HTML_Elements.p([ PartyCarlo_Components_HTML_Utils.css("error") ])([ Halogen_HTML_Core.text(Data_Maybe.maybe(" ")(display1)(v.value0.e)) ]), Halogen_HTML_Elements.textarea([ Halogen_HTML_Properties.id("input"), value(v.value0.input), Halogen_HTML_Events.onClick(function (v1) {
                                return ClearDefaultText.value;
                            }), Halogen_HTML_Events.onValueInput(ReceiveInput.create) ]), PartyCarlo_Components_HTML_Footer.footer ]);
                        };
                        if (v instanceof Loading) {
                            return Halogen_HTML_Elements.div([ Halogen_HTML_Properties.id("root"), PartyCarlo_Components_HTML_Utils.css("vcontainer noselect") ])([ titleButton, PartyCarlo_Components_HTML_Loading.loadingAnimation, renderToggleRow(Loading.value), PartyCarlo_Components_HTML_Footer.footer ]);
                        };
                        if (v instanceof Results) {
                            return Halogen_HTML_Elements.div([ Halogen_HTML_Properties.id("root"), PartyCarlo_Components_HTML_Utils.css("vcontainer") ])([ titleButton, PartyCarlo_Components_HTML_ResultCircle.resultCircle(v.value0.result)(v.value0.show), renderToggleRow(new Results(v.value0)), PartyCarlo_Components_HTML_Footer.footer ]);
                        };
                        throw new Error("Failed pattern match at PartyCarlo.Pages.Home (line 105, column 5 - line 105, column 55): " + [ v.constructor.name ]);
                    };
                    var initialState = function (s) {
                        return new Data({
                            input: s,
                            e: Data_Maybe.Nothing.value
                        });
                    };
                    var handleAction = function (dictMonadAff1) {
                        return function (dictLogMessages1) {
                            return function (dictNow1) {
                                return function (dictRandom1) {
                                    return function (dictSleep1) {
                                        return function (action) {
                                            return bind(get)(function (state) {
                                                return handleAction$prime4(state)(action);
                                            });
                                        };
                                    };
                                };
                            };
                        };
                    };
                    return Halogen_Component.mkComponent({
                        initialState: initialState,
                        render: render,
                        "eval": Halogen_Component.mkEval({
                            handleAction: handleAction(dictMonadAff)(dictLogMessages)(dictNow)(dictRandom)(dictSleep),
                            handleQuery: Halogen_Component.defaultEval.handleQuery,
                            receive: Halogen_Component.defaultEval.receive,
                            initialize: Halogen_Component.defaultEval.initialize,
                            finalize: Halogen_Component.defaultEval.finalize
                        })
                    });
                };
            };
        };
    };
};
export {
    ReceiveInput,
    ButtonPress,
    ClearDefaultText,
    ResultUp,
    ResultDown,
    Data,
    Results,
    Loading,
    experimentCount,
    defaultTextAreaValue,
    component,
    handleAction$prime,
    runExperiments,
    parse,
    parseNum,
    stripInput
};
